import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Endpoints} from "../../customs/endpoints";
import {CommonResponse} from "../../customs/_models/Response";
import {Observable, catchError, of} from "rxjs";
import {OT_DTO} from "../../customs/_models/OT_DTO";
import {AnalyseDTO} from "../../customs/_models/analyse.dtos";
import {DialogService} from "../../customs/_modal/dialog.service";
import {SampleDTO} from "../../customs/_models/sampleDTO";
import { AccDTO } from '../../customs/_models/AccDTO';
import { Task } from '../../customs/_models/taskDTO';

@Injectable({
    providedIn: 'root'
})
export class TaskService {


  constructor(private http: HttpClient,private endPoint:Endpoints) {}

  // 🔹 GET ALL
  getAllTasks(): Observable<Task[]> {
    return this.http.get<Task[]>(this.endPoint.task_base_endpoint);
  }

  // 🔹 CREATE
  createTask(task: Task): Observable<Task> {
    return this.http.post<Task>(this.endPoint.task_base_endpoint, task);
  }

  // 🔹 UPDATE
  updateTask(id: number, task: Task): Observable<Task> {
    return this.http.put<Task>(`${this.endPoint.task_base_endpoint}/${id}`, task);
  }

  // 🔹 DELETE
  deleteTask(id: number): Observable<void> {
    return this.http.delete<void>(`${this.endPoint.task_base_endpoint}/${id}`);
  }
}